<template>
  <div>
    <span>Store Vue - 2020</span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  font-family: "Satisfy";
  padding: 1rem 2rem;
  color: #f5f5f5;
  background: hsl(267, 73%, 3%);
}
</style>
